// extracted by mini-css-extract-plugin
export default {"container":"DoorLocks_container__6vQqz","header":"DoorLocks_header__SllDx","image":"DoorLocks_image__dl2QM","title":"DoorLocks_title__+GCuj","count":"DoorLocks_count__Ze6Te"};